import axios from 'axios'

export const getBrands = ({ commit }) => {
  commit('setLoading', true);
  axios.get('/api/brands/getBrands')
    .then(response => {
      commit('getBrands', response.data.data)
    })
    .catch(e => {
      console.error('brands/getBrands:', e);
      commit('getBrands', []);
    })
    .finally(() => {
      commit('setLoading', false);
    });
}